export const SIGNALS_OPTED_IN_CELEBRATION = {
  subtitleSuffix: "and you're in the queue to get Subscriber Signals.",
  message: "We'll email you as soon as your data starts syncing."
}
